import React, { useEffect } from 'react';
import { useFormContext } from "react-hook-form";
import { Card, CardContent, Grid } from '@material-ui/core'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { components, DataFlattener, useTranslation } from 'cng-web-lib'
import ValidationSchema from './ValidationSchema'
import Namespace from 'src/constants/locale/Namespace'
import CommunicationUtilKeys from 'src/constants/locale/key/CommunicationUtil'

const {
  card: { },
  form: {
    field: { CngTextField }
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  commsType: "",
  commsRecipient: "",
  commsSubject: "",
  commsContent: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: ValidationSchema
}

function Fields({ disabled, showNotification, shouldHideMap }) {
  const { setValue, getValues, reset } = useFormContext();
  const { translate } = useTranslation(Namespace.COMMUNICATION_UTIL)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let commsType = translate(
      Namespace.COMMUNICATION_UTIL,
      CommunicationUtilKeys.COMMS_TYPE
    )
    let commsRecipient = translate(
      Namespace.COMMUNICATION_UTIL,
      CommunicationUtilKeys.COMMS_RECIPIENT
    )
    let commsSubject = translate(
      Namespace.COMMUNICATION_UTIL,
      CommunicationUtilKeys.COMMS_SUBJECT
    )
    let commsContent = translate(
      Namespace.COMMUNICATION_UTIL,
      CommunicationUtilKeys.COMMS_CONTENT
    )

    return {
      commsType,
      commsRecipient,
      commsSubject,
      commsContent
    }
  }

  useEffect(() => { setValue("commsType", "Email", { shouldValidate: true }) }, []);


  const commTypeChangeHandler = (event) => {
    let type = event.target.value;
    if (type == "sms") {
      reset();
      setValue("commsType", "SMS", { shouldValidate: true })
    } else {
      reset();
      setValue("commsType", "Email", { shouldValidate: true })
    }
  }

  function getRecipientLabel() {
    if (getValues("commsType") == "Email") {
      return "Recipient Email Address: "
    }
    return "Recipient Phone Number: "
  }

  function getHiddenByCommsType() {
    if (getValues("commsType") == "Email") {
      return false;
    }
    return true;
  }

  const styles = {
    textField: { width: '50%' }
  };

  return (
    <Card>
      <CardContent>
        <Grid container spacing={3}>
          <CngGridItem xs={12} sm={12} style={{ paddingBottom: 5 }}><h1>Communication Tool</h1></CngGridItem>
          <CngGridItem xs={12} sm={12} style={{ color: "grey", paddingTop: 0 }}><p>(Use this tool to send Email/SMS to local and overseas recipients.)</p></CngGridItem>
        </Grid>
        <hr />
        <Grid container spacing={3} style={{ paddingTop: 20 }}>
          <CngGridItem xs={12} sm={12}><h3>{getValues("commsType")} Information</h3></CngGridItem>
          <CngGridItem xs={12} sm={12}>
            <FormControl component="fieldset">
              <FormLabel>Communication Type:</FormLabel>
              <RadioGroup row aria-label="Communication Type" name="commsType" defaultValue="email" onChange={commTypeChangeHandler}>
                <FormControlLabel value="email" control={<Radio color="primary" />} label="Email" />
                <FormControlLabel value="sms" control={<Radio color="primary" />} label="SMS" />
              </RadioGroup>
            </FormControl>
          </CngGridItem>
          <CngGridItem xs={12} sm={12}>
            <CngTextField name="commsRecipient" label={getRecipientLabel()} required style={styles.textField} />
          </CngGridItem>
          <CngGridItem xs={12} sm={12} shouldHide={getHiddenByCommsType()}>
            <CngTextField name="commsSubject" label={translatedTextsObject.commsSubject} required style={styles.textField}
              onChange={(e) => {
                setValue("commsSubject", e.target.value, { shouldValidate: true })
              }}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={12}>
            <CngTextField name="commsContent" label={translatedTextsObject.commsContent} required multiline rows={7} style={styles.textField} />
          </CngGridItem>
        </Grid>
      </CardContent>
    </Card>
  )
}

function toClientDataFormat(serverData) {
  let localData = DataFlattener.parse(serverData);
  return localData;
}

function toServerDataFormat(localData) {
  return DataFlattener.unflatten(localData);
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default FormProperties
